import React from 'react';
// Components - imported
import { Avatar } from '@material-ui/core';
import DefaultAvatar from 'react-avatar';

// Icon
import CheckIcon from '@material-ui/icons/Check';

const GroupBlock_Mini = ({
    group_doc,
    handleClick,
    active
}) => {
    
    return (
        <div key={group_doc._id} onClick={() => handleClick(group_doc)} className="userTable__block">
            {/* User Avatar - left */}
            <div className="userTable__avatar">
                {group_doc.avatar ? (
                    <Avatar src={group_doc.avatar} />
                ) : (
                    <DefaultAvatar name={`${group_doc.name}`} />
                )}
            </div>

            {/* Display the user's name & username */}
            <div className="userTable__info">
                <h3>
                    {group_doc.name}
                </h3>
                <div style={{display: 'flex', alignItems: 'center', marginTop: '2px', fontSize:'13px', color: 'rgb(83, 100, 113)'}}>
                    {group_doc.follower_count || '--'} member{group_doc.follower_count !== 1 && 's'}
                </div>
            </div>
            
            {active && (
                <div style={{height: '100%', display: 'flex', alignItems: 'center', paddingRight: '10px', color: 'rgb(29, 155, 240)'}}>
                    <CheckIcon />
                </div>
            )}
        </div>
    )
}

export default GroupBlock_Mini;